import { actionTypeCreator } from './util'
import { currentUserId } from 'utils/auth'

// /////////////////////////////////////////////////////////////////////////////
// Constants
// /////////////////////////////////////////////////////////////////////////////
export const constants = {
  NAME: 'auth'
}

// /////////////////////////////////////////////////////////////////////////////
// Action Types
// /////////////////////////////////////////////////////////////////////////////
const createActionType = actionTypeCreator.bind(null, constants.NAME)
export const LOGOUT = createActionType('LOGOUT')
export const LOGIN = createActionType('LOGIN')
export const LOGIN_STARTED = createActionType('LOGIN_STARTED')
export const LOGIN_SUCCESS = createActionType('LOGIN_SUCCESS')
export const LOGIN_FAILURE = createActionType('LOGIN_FAILURE')
export const SIGNUP = createActionType('SIGNUP')
export const SIGNUP_STARTED = createActionType('SIGNUP_STARTED')
export const SIGNUP_SUCCESS = createActionType('SIGNUP_SUCCESS')
export const SIGNUP_FAILURE = createActionType('SIGNUP_FAILURE')
export const LOAD_JWT_FROM_GLOBAL = createActionType('LOAD_JWT_FROM_GLOBAL')
export const SET_CURRENT_USER = createActionType('SET_CURRENT_USER')
export const FB_LOGIN = createActionType('FB_LOGIN')

// /////////////////////////////////////////////////////////////////////////////
// Actions
// /////////////////////////////////////////////////////////////////////////////
export function logout () {
  return {
    type: LOGOUT
  }
}

export function login (data, next = '/') {
  const {
    email,
    password
  } = data

  return {
    type: LOGIN,
    payload: {
      email,
      password
    },
    meta: {
      next
    }
  }
}

export function fbLogin (data, next = '/') {
  return {
    type: FB_LOGIN,
    payload: data,
    meta: {
      next
    }
  }
}

export function signup (data, next = '/') {
  const {
    firstName,
    lastName,
    email,
    password,
    passwordConfirmation
  } = data

  return {
    type: SIGNUP,
    payload: {
      firstName,
      lastName,
      email,
      password,
      passwordConfirmation
    },
    meta: {
      next
    }
  }
}

export function setCurrentUser (userId) {
  currentUserId.set(userId)

  return {
    type: SET_CURRENT_USER,
    payload: userId
  }
}

// /////////////////////////////////////////////////////////////////////////////
// Queries
// /////////////////////////////////////////////////////////////////////////////
export const isLoggedIn = (globalState) => {
  const isProduction = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging'

  const aliadaJwtPresent = !!(window.aliada && window.aliada.jwt)
  const userIdPresent = !!(globalState[constants.NAME].userId)

  return isProduction
    ? aliadaJwtPresent || userIdPresent
    : userIdPresent
}
export const isAuthenticating = (globalState) => !!globalState[constants.NAME].authenticating

// /////////////////////////////////////////////////////////////////////////////
// Selectors
// /////////////////////////////////////////////////////////////////////////////
export const getCurrentUser = (globalState) => globalState[constants.NAME].userId

// /////////////////////////////////////////////////////////////////////////////
// Reducer
// /////////////////////////////////////////////////////////////////////////////
const initialState = {
  userId: undefined, // This value is initialized in @src/redux/store/initialState
  authenticating: false
}

export function reducer (state = initialState, action = {}) {
  const {
    payload,
    type
  } = action
  switch (type) {
    case LOGIN_STARTED:
    case SIGNUP_STARTED:
      return {
        ...state,
        authenticating: true
      }
    case LOGIN_SUCCESS:
    case SIGNUP_SUCCESS:
      return {
        ...state,
        userId: payload.userId,
        authenticating: false
      }
    case LOGIN_FAILURE:
    case SIGNUP_FAILURE:
      return {
        ...state,
        authenticating: false
      }

    case SET_CURRENT_USER:
      return {
        ...state,
        userId: payload
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/auth.js